import { isFunction } from "lodash";
import React from 'react';
import SVGMap from './SVGMap';
import { getLocationName, getLocationSelected, getLocationId } from './utils';
import './checkbox-map.css';

class CheckboxMap extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			pointedLocation: null,
			focusedLocation: null,
      selected: {},
      tooltipStyle: {
        display: 'none'
      }
		};
    this.map = props.map;

		this.handleLocationMouseOver = this.handleLocationMouseOver.bind(this);
    this.handleLocationMouseMove = this.handleLocationMouseMove.bind(this);
		this.handleLocationMouseOut = this.handleLocationMouseOut.bind(this);
		this.handleLocationClick = this.handleLocationClick.bind(this);
		this.handleLocationFocus = this.handleLocationFocus.bind(this);
		this.handleLocationBlur = this.handleLocationBlur.bind(this);
    this.isLocationSelected = this.isLocationSelected.bind(this);
		this.pushNotification = this.pushNotification.bind(this);
	}

  pushNotification(){
    if(isFunction(this.props.onUpdate)){
      this.props.onUpdate(this.state.selected);
    }
  }
	handleLocationMouseOver(event) {
		const pointedLocation = getLocationName(event);
		this.setState({ pointedLocation });
	}

	handleLocationMouseOut() {
    this.setState({ pointedLocation: null, tooltipStyle: { display: 'none' } });
	}

  handleLocationMouseMove(event) {
    const { clientY=0, clientX=0} = this.props;
		const tooltipStyle = {
			display: 'block',
			top: event.clientY + clientY,
			left: event.clientX + clientX
		};
		this.setState({ tooltipStyle });
	}

	handleLocationClick(event) {
    const locationName = getLocationName(event);
		const locationId = getLocationId(event);
		const isSelected = getLocationSelected(event);

		this.setState(prevState => {
      let selected = Object.assign({}, prevState.selected);

			if (isSelected) {
        delete selected[locationId];
			} else {
        selected[locationId] = locationName;
			}

      return { ...prevState, selected };
		}, this.pushNotification);
	}

	handleLocationFocus(event) {
		const focusedLocation = getLocationName(event);
		this.setState({ focusedLocation: focusedLocation });
	}

	handleLocationBlur() {
		this.setState({ focusedLocation: null });
	}

	isLocationSelected(location) {
    for(let id in this.state.selected){
      let name = this.state.selected[id];
      if(name===location.name){
        return true;
      }
    }
    return false;
	}

  render(){
    return (
      <div style={{display: 'inline-block', position: 'relative'}}>
      <SVGMap
        map={this.map}
        width={this.props.width}
        type="checkbox"
        onLocationMouseOver={this.handleLocationMouseOver}
        onLocationMouseOut={this.handleLocationMouseOut}
        onLocationMouseMove={this.handleLocationMouseMove}
        onLocationClick={this.handleLocationClick}
        onLocationFocus={this.handleLocationFocus}
        onLocationBlur={this.handleLocationBlur}
        isLocationSelected={this.isLocationSelected} />
        <div className="svg-map__tooltip" style={this.state.tooltipStyle}>
          {this.state.pointedLocation}
        </div>
      </div>
    )
  }

}

export default CheckboxMap;



// WEBPACK FOOTER //
// ./src/components/SVGMaps/components/checkbox-map.js